import { render, staticRenderFns } from "./BookingsListPage.vue?vue&type=template&id=737ca8d0&"
import script from "./BookingsListPage.vue?vue&type=script&lang=ts&"
export * from "./BookingsListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports